import { APP_CONFIG, SOCIAL_CONFIG } from '@/config';

import { COMMON_CONTENT } from './common';

export const FOOTER_CONTENT = {
  brand: {
    name: COMMON_CONTENT.brand.name,
    tagline: COMMON_CONTENT.brand.tagline,
    description: 'Bringing joy and comfort with handcrafted soft toys since 2026.',
  },
  quickLinks: {
    title: 'Company',
    links: [
      { id: 'about', label: 'About Us', path: '/about' },
      { id: 'contact', label: 'Contact', path: '/contact' },
      { id: 'faq', label: 'FAQs', path: '/faq' },
      { id: 'care', label: 'Care Instructions', path: '/care-instructions' },
      { id: 'gift-guide', label: 'Gift Guide', path: '/gift-guide' },
    ],
  },
  shopLinks: {
    title: 'Shop',
    links: [
      { id: 'teddy-bears', label: 'Teddy Bears', path: '/shop?category=FILLED TEDDY' },
      { id: 'dolls', label: 'Dolls', path: '/shop?category=FILLED DOLL' },
      { id: 'all-products', label: 'All Products', path: '/shop' },
      { id: 'new-arrivals', label: 'New Arrivals', path: '/shop?sort=newest' },
      { id: 'sale', label: 'Sale Items', path: '/shop?sale=true' },
    ],
  },
  helpLinks: {
    title: 'Support',
    links: [
      { id: 'account', label: 'My Account', path: '/account' },
      { id: 'orders', label: 'Order History', path: '/orders' },
      { id: 'wishlist', label: 'Wishlist', path: '/wishlist' },
      { id: 'shipping', label: 'Shipping & Returns', path: '/shipping-returns' },
      { id: 'size-guide', label: 'Size Guide', path: '/size-guide' },
    ],
  },
  legalLinks: {
    title: 'Legal',
    links: [
      { id: 'privacy', label: 'Privacy Policy', path: '/privacy-policy' },
      { id: 'terms', label: 'Terms of Service', path: '/terms-of-service' },
    ],
  },
  social: {
    title: 'Follow us:',
    platforms: [
      { id: 'youtube', label: 'YouTube', href: SOCIAL_CONFIG.youtube, icon: 'Youtube' },
      { id: 'instagram', label: 'Instagram', href: SOCIAL_CONFIG.instagram, icon: 'Instagram' },
      { id: 'facebook', label: 'Facebook', href: SOCIAL_CONFIG.facebook, icon: 'Facebook' },
    ],
  },
  payment: {
    title: 'We accept:',
    methods: ['Visa', 'Mastercard', 'UPI'],
  },
  contact: {
    title: 'Contact Us',
    email: COMMON_CONTENT.brand.email,
    emailLabel: 'Email',
    phone: COMMON_CONTENT.brand.phone,
    phoneLabel: 'Phone',
    address: COMMON_CONTENT.brand.address,
    addressLabel: 'Address',
  },
  copyright: {
    text: `© ${new Date().getFullYear()} ${APP_CONFIG.name}. All rights reserved.`,
  },
} as const;
